import { useAmp } from 'next/amp';
import Link from 'next/link';
import React, { FC } from 'react';
import DefaultImage from './DefaultImage';
import FullWidthImage from './FullWidthImage';

const ImageWithCaption = ({
  slice,
}: {
  slice: {
    primary: { image?: any; caption?: any; href?: string };
    slice_label: string;
  };
}) => {
  const isAmp = useAmp();

  const Wrapper: FC = ({ children }) =>
    slice.primary.href ? (
      <Link href={slice.primary.href} passHref>
        <a style={{ textDecoration: 'none' }}>{children}</a>
      </Link>
    ) : (
      <>{children}</>
    );

  if (isAmp) {
    return (
      <div style={{ marginBottom: 16 }}>
        <Wrapper>
          <amp-img
            alt={slice.primary.caption}
            src={slice.primary.image.url}
            width={slice.primary.image.dimensions.width}
            height={slice.primary.image.dimensions.height}
            layout="responsive"
          />
        </Wrapper>
      </div>
    );
  }

  const imageComponent =
    slice.slice_label === 'image-full-width' ? (
      <FullWidthImage slice={slice} />
    ) : (
      <DefaultImage slice={slice} />
    );

  return <Wrapper>{imageComponent}</Wrapper>;
};

export default ImageWithCaption;
